module.exports = __webpack_public_path__ + "img/vodoun.c9d96eb1.jpeg";